export { FeedItem } from './FeedItem'
export type { FeedItemProps } from './FeedItem'
